import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

export const SkeletonHostAchievement = () => (
  <Box className={styles['skeleton-host-achievement__container']} data-testid="skeleton-host-achievement__container">
    <Box className={styles['achievement-header__section']}>
      <Flex gap="12px">
        <SkeletonComponent width="28px" height="28px" mb="6px" />
        <Flex flexDirection="column">
          <SkeletonComponent width="110px" height="16px" mb="6px" />
          <SkeletonComponent width="80px" height="10px" mb="6px" />
        </Flex>
      </Flex>
      <SkeletonComponent width="16px" height="16px" mb="6px" />
    </Box>
    <Box className={styles['achievement-brand-progress__section']}>
      <Box className={styles['top-progress__section']}>
        <SkeletonComponent width="40%" height="14px" mb="6px" />
        <SkeletonComponent width="64%" height="10px" mb="6px" />
        <Flex gap="4px" alignItems="center">
          <SkeletonComponent width="90%" height="8px" mb="4px" />
          <SkeletonComponent width="10%" height="10px" mb="4px" />
        </Flex>
      </Box>
      <Box className={styles['bottom-progress__section']}>
        <Flex width="56%">
          <Box className={styles['bottom-progress__item']}>
            <SkeletonComponent width="40%" height="14px" mb="6px" />
            <SkeletonComponent width="64%" height="10px" mb="6px" />
            <Flex gap="4px" alignItems="center">
              <SkeletonComponent width="50%" height="8px" mb="4px" />
              <SkeletonComponent width="30%" height="10px" mb="4px" />
            </Flex>
          </Box>
          <Box className={styles['bottom-progress__item']}>
            <SkeletonComponent width="40%" height="14px" mb="6px" />
            <SkeletonComponent width="64%" height="10px" mb="6px" />
            <Flex gap="4px" alignItems="center">
              <SkeletonComponent width="50%" height="8px" mb="4px" />
              <SkeletonComponent width="30%" height="10px" mb="4px" />
            </Flex>
          </Box>
        </Flex>
        <Box className={styles['bottom-progress__item']}>
          <SkeletonComponent width="40%" height="14px" mb="6px" />
          <SkeletonComponent width="64%" height="10px" mb="6px" />
          <Flex gap="4px" alignItems="center">
            <SkeletonComponent width="90%" height="8px" mb="4px" />
            <SkeletonComponent width="10%" height="10px" mb="4px" />
          </Flex>
        </Box>
      </Box>
    </Box>
  </Box>
);

export const SkeletonHostAttendance = () => (
  <Box className={styles['skeleton-host-attendance__container']} data-testid="skeleton-host-attendance__container">
    <Box className={styles['bento__item']} height="138px">
      <Box height="42px">
        <SkeletonComponent width="40%" height="20px" />
      </Box>

      <Flex flexDir="column" gap="8px">
        <SkeletonComponent width="100%" height="42px" />
        <Flex gap="8px">
          <SkeletonComponent width="5%" height="20px" />
          <SkeletonComponent width="80%" height="20px" />
        </Flex>
      </Flex>
    </Box>
  </Box>
);

export const SkeletonHostOverview = () => (
  <Box className={styles['skeleton-host-overview__container']} data-testid="skeleton-host-overview__container">
    <Flex className={styles['bento__list']}>
      <Iteration
        items={[1, 2]}
        render={(index) => (
          <Box className={styles['bento__item']} key={index}>
            <Flex marginBottom="8px" justifyContent={"space-between"}>
              <SkeletonComponent width="30px" height="20px" mb="2px" />
              <SkeletonComponent width="30px" height="20px" mb="2px" />
            </Flex>

            <Flex justifyContent="space-between" mb="10px">
              <SkeletonComponent width="36px" height="20px" />
            </Flex>
          </Box>
        )}
      />
    </Flex>
    <Flex className={styles['bento__list']}>
      <Iteration
        items={[1, 2, 3]}
        render={(index) => (
          <Box className={styles['bento__item']} key={index}>
            <Box marginBottom="8px">
              <SkeletonComponent width="100%" height="20px" mb="2px" />
              <SkeletonComponent width="70%" height="20px" />
            </Box>

            <Flex justifyContent="space-between" mb="10px">
              <SkeletonComponent width="36px" height="20px" />
              <SkeletonComponent width="12px" height="20px" />
            </Flex>
          </Box>
        )}
      />
    </Flex>
  </Box>
);

export const SkeletonHostSchedule = () => (
  <Box className={styles['skeleton-host-schedule__container']} data-testid="skeleton-host-schedule__container">
    <SkeletonComponent height="20px" mb="12px" width="110px" />
    <SkeletonComponent height="12px" mb="12px" width="170px" />

    <Box className={styles['card__section']}>
      <Iteration
        items={[1, 2, 3]}
        render={(num) => (
          <Box className={styles['card']} key={num}>
            <Flex className={styles['head-card__section']}>
              <SkeletonComponent height="18px" width="80%" />
              <SkeletonComponent height="18px" width="18px" />
            </Flex>
            <SkeletonComponent height="12px" width="136px" mb="6px" />
          </Box>
        )}
      />
    </Box>
  </Box>
);
